import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { langTranslateHttpLoader } from 'src/app/lang-translate.loader';
//import { ModalPopoverComponent } from './modal-popover/modal-popover.component';
import { UserRolePipe } from './pipes/userRole/user-role.pipe';
import { BusinessFunctionPipe } from './pipes/business-function.pipe';
import { TimestampToDatePipe } from './pipes/timestamp-to-date.pipe';
import { SplitCamelCaseTitlePipe } from './pipes/split-camel-case-title.pipe';
import { RangeScaleComponent } from './range-scale/range-scale.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';

@NgModule({
  declarations: [
    //   ModalPopoverComponent,
    UserRolePipe,
    BusinessFunctionPipe,
    TimestampToDatePipe,
    SplitCamelCaseTitlePipe,
    RangeScaleComponent,
  ],
  imports: [
    CommonModule, // for getting acces to all the realtime directives in Angular like ngIf , ngFor etc...
    ReactiveFormsModule,
    FormsModule,
    NgxSliderModule,
    ModalModule,
    PaginationModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: langTranslateHttpLoader,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    ModalModule,
    PaginationModule,
    //   ModalPopoverComponent,
    UserRolePipe,
    BusinessFunctionPipe,
    TimestampToDatePipe,
    SplitCamelCaseTitlePipe,
    NgxSliderModule,
    RangeScaleComponent,
  ],
})
export class SharedModule {}
